import React from 'react';
import ReactDom from 'react-dom/client';
import {Provider} from 'react-redux';
import store from './store';
import './assets/css/slim.css';
import './assets/css/font-awesome.css';
import './assets/css/ionicons.css';
import './assets/css/select2.min.css';
import './assets/css/jquery.dataTables.css';
import App from './containers/app/app.jsx';
import  './assets/css/custom.css'
import './index.css';

const root = ReactDom.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>
);